var React = require('react');

function BlueTriangle (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Rectangle"),React.createElement("g",{"id":"Aurelius-2.0","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"Homepage-–-V1","transform":"translate(0.000000, -640.000000)","fill":"#5DBACA"},React.createElement("g",{"id":"Group-17","transform":"translate(0.000000, 640.000000)"},React.createElement("polygon",{"id":"Rectangle","points":"0 0 283.011976 0 0 154"}))))]);
}

BlueTriangle.defaultProps = {"width":"283px","height":"154px","viewBox":"0 0 283 154","version":"1.1"};

module.exports = BlueTriangle;

BlueTriangle.default = BlueTriangle;
